

















import { Route } from 'vue-router';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

export interface TabData {
  label: string;
  routeName: string;
}

@Component
export default class AppTabs extends Vue {

  @Prop({ default: false }) private vertical!: boolean;

  private currentRouteName: string|null = null;

  /**
   * Should the slider be shown.
   */
  private showSlider = false;

  /**
   * Tabs displayed.
   */
  get tabs(): TabData[] {
    const tabs: TabData[] = [
      { label: this.$t('welcome.welcome').toString(), routeName: 'home' },
      { label: this.$t('gallery.gallery').toString(), routeName: 'gallery' },
    ];
    if (this.$store.state.user != null) {
      tabs.push({ label: this.$t('admin.admin').toString(), routeName: 'admin' });
    }
    return tabs;
  }

  mounted() {
    this.routeUpdate(this.$route);
  }

  @Watch('$route')
  private routeUpdate(route: Route) {
    this.currentRouteName = route.name ?? null;
    this.showSlider = this.tabs.some(tab => tab.routeName == this.currentRouteName);
  }

}
